module.exports = __webpack_public_path__ + "img/banner_1.1176c5b7.jpg";